/* MonKoku Maison · gemeinsame Duft-Daten (Baukasten, Duftsuche, Vergleich) */
(function () {
  'use strict';
  if (window.MKS) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var themeId = (window.Shopify && Shopify.theme && Shopify.theme.id) || 0;
  var KEY = 'mks:' + themeId + ':v1';
  var TTL = 30 * 60 * 1000;
  var promise = null;
  var FAM = { aromatisch: 'Aromatisch', blumig: 'Blumig', cremig: 'Cremig', frisch: 'Frisch', fruchtig: 'Fruchtig', holzig: 'Holzig', ledrig: 'Ledrig', orientalisch: 'Orientalisch', suess: 'Süß', wuerzig: 'Würzig' };
  var GEN = { d: 'Damen', h: 'Herren', u: 'Unisex' };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function norm(s) {
    return String(s || '').toLowerCase().replace(/ß/g, 'ss').normalize('NFD').replace(/[̀-ͯ]/g, '');
  }
  function money(cents) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }
  function prep(it) {
    var tg = String(it.tg || '').toLowerCase().split(',');
    it.g = tg.indexOf('herrendüfte') > -1 ? 'h' : tg.indexOf('damendüfte') > -1 ? 'd' : 'u';
    it.f = tg.filter(function (t) { return t.indexOf('duft-') === 0; }).map(function (t) { return t.slice(5); });
    it.best = tg.indexOf('bestseller') > -1;
    it.n = [].concat(it.nk || [], it.nh || [], it.nb || [], it.nf || []);
    it.img = it.i ? (it.i.indexOf('//') === 0 ? 'https:' + it.i : it.i) : '';
    it.url = root + 'products/' + it.h;
    it.q = norm([it.t, it.k, it.n.join(' '), (it.r || []).join(' '), it.f.map(function (f) { return FAM[f] || f; }).join(' '), (it.s || []).join(' '), (it.o || []).join(' ')].join(' '));
    return it;
  }

  function load() {
    if (promise) return promise;
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (c && Date.now() - c.t < TTL && c.items && c.items.length) { promise = Promise.resolve(c.items.map(prep)); return promise; }
    } catch (e) { /* ohne Speicher weiter */ }
    function page(n) {
      return fetch(root + 'collections/all?view=mkdata&page=' + n)
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
        .then(function (t) { return JSON.parse(t); });
    }
    promise = page(1).then(function (j) {
      var rest = [];
      for (var n = 2; n <= (j.pages || 1); n++) rest.push(page(n));
      return Promise.all(rest).then(function (more) {
        var items = j.items.slice();
        more.forEach(function (x) { items = items.concat(x.items); });
        return items;
      });
    }).then(function (items) {
      try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), items: items })); } catch (e) { /* egal */ }
      return items.map(prep);
    }).catch(function (e) { promise = null; throw e; });
    return promise;
  }

  /* In den Warenkorb, optional mit Aktionscode, danach Warenkorb öffnen */
  function addToCart(items, code) {
    var sections = [];
    document.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { detail: { sections: sections } }));
    var secs = sections.join(',');
    var h = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
    function body(o) { if (secs) { o.sections = secs; o.sections_url = location.pathname; } return JSON.stringify(o); }
    function J(r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Fehler'); return d; }); }
    var p = fetch(root + 'cart/add.js', { method: 'POST', headers: h, body: code ? JSON.stringify({ items: items }) : body({ items: items }) }).then(J);
    if (code) {
      p = p.then(function () { return fetch(root + 'cart.js').then(J); }).then(function (c) {
        var codes = (c.discount_codes || []).map(function (x) { return x.code; });
        if (!codes.some(function (x) { return x.toUpperCase() === code.toUpperCase(); })) codes.push(code);
        return fetch(root + 'cart/update.js', { method: 'POST', headers: h, body: body({ discount: codes.join(',') }) }).then(J);
      });
    } else {
      p = p.then(function (r) { return fetch(root + 'cart.js').then(J).then(function (c) { c.sections = r.sections; return c; }); });
    }
    return p.then(function (c) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: c } }));
      return c;
    });
  }

  /* Vergleichsliste (max. 3), bleibt im Browser */
  var CK = 'mks:cmp', CMAX = 3;
  function cmpGet() { try { var a = JSON.parse(localStorage.getItem(CK) || '[]'); return Array.isArray(a) ? a.slice(0, CMAX) : []; } catch (e) { return []; } }
  function cmpSet(a) {
    try { localStorage.setItem(CK, JSON.stringify(a.slice(0, CMAX))); } catch (e) { /* egal */ }
    document.dispatchEvent(new CustomEvent('mks:cmp', { detail: { list: a.slice(0, CMAX) } }));
  }
  function cmpToggle(h) {
    var a = cmpGet(), i = a.indexOf(h);
    if (i > -1) { a.splice(i, 1); cmpSet(a); return { on: false, full: false }; }
    if (a.length >= CMAX) return { on: false, full: true };
    a.push(h); cmpSet(a);
    return { on: true, full: false };
  }

  window.MKS = { root: root, FAM: FAM, GEN: GEN, esc: esc, norm: norm, money: money, load: load, addToCart: addToCart, cmp: { get: cmpGet, set: cmpSet, toggle: cmpToggle, max: CMAX } };
})();